import { useFpB2bPaymentService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-payment-service'
import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { useApiGetFpPayment } from '@hooks-api/fortune/useApiGetFpPayment'
import { PaymentMethodType, PaymentServiceType } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { PayMe } from '@pets-ui/icons'
import { Radio } from '@pets-ui/Radio/Radio'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom-v5'
import { useContextPayment } from '../../../../fp-b2b-shared/components/PaymentProvider/PaymentProvider'
import { useCheckout } from '../../../../fp-b2b-shared/hooks/use-checkout'
import { paymentComponentStyle } from './PaymentMethodComponent'

export const PaymentPayMe = () => {
  const { trigger: getPaymentToken } = useApiGetFpPayment()
  const { selectedPayment, setSelectedPayment, paymentMethods, setPaymentExecution, setConfiguredPaymentModule, isSdkInitialized, setIsLoadingPayment } = useContextPayment()
  const { campaignId, campaignCode, platform } = useCheckout()

  const checked = selectedPayment?.service_type === PaymentServiceType.PAYME && selectedPayment.type === PaymentMethodType.PAYME
  const currentMethod = paymentMethods.find(method => method.service_type === PaymentServiceType.PAYME && method.type === PaymentMethodType.PAYME)

  const { transactionId: paymentTransactionIdFromUrl } = useParams<{ transactionId?: string }>()
  const { orderId, orderType } = useFpB2bPaymentService({ campaignId, paymentTransactionIdFromUrl, campaignCode, platform })
  const handleSelectPayment = useCallbackEvent(async () => {
    try {
      if (!campaignCode) {
        throw new Error('Missing campaign code')
      }
      if (!currentMethod) {
        throw new Error('Missing payment method')
      }
      setSelectedPayment(currentMethod)

      setIsLoadingPayment(true)
      const token = await getPaymentToken({
        order_type: orderType,
        order_id: orderId,
        payment_method_id: currentMethod.id,
      })

      const { payment_transaction_id } = token.data.data
      setPaymentExecution({
        payment_transaction_id,
        service_pay_info: null,
        user_payment_token_info: undefined,
        payment_success_url: '',
        payment_fallback_url: '',
      })
      setConfiguredPaymentModule(undefined)
    }
    catch (error) {
      console.error(`[PaymentPayMe] ${error}`)
    }
    finally {
      setIsLoadingPayment(false)
    }
  })

  const handleInitPayment = useCallback(async () => {
    // NOTE: isSdkInitialized promises that the payment module is init after sdk init
    const shouldInit = selectedPayment?.service_type === PaymentServiceType.PAYME && selectedPayment.type === PaymentMethodType.PAYME && isSdkInitialized
    if (!shouldInit) return
    handleSelectPayment()
  }, [handleSelectPayment, isSdkInitialized, selectedPayment?.service_type, selectedPayment?.type])

  // NOTE: init for default payment
  useEffect(() => {
    handleInitPayment()
  }, [handleInitPayment])

  return (
    <Box component="label" rootStyle={[paymentComponentStyle.root, paymentComponentStyle.radioPaymentChecked]}>
      <VStack flexGrow={1} gap={2.5}>
        <HStack alignItems="center" gap={2}>
          <Radio
            name="paymentPayMe"
            checked={checked}
            value="paymentPayMe"
            onChange={handleSelectPayment}
          />
          <PayMe style={{ color: '#DB0011' }} />
          <Text fontWeight={600} lineHeight="100%">PayMe</Text>
          <Box flexGrow={1} />
          {/* endIcon */}
        </HStack>
      </VStack>
    </Box>
  )
}
